import styled, { css } from "styled-components";
import { FC } from "react";
import { components } from "react-select";

import { SelectComponentProps } from "./types";
import { styleWrappedComponent } from "./styleWrappedComponent";
import { alpha } from "../../../typography";

const StyledGroupHeading = styled.div`
  position: sticky;
  top: 0;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-left: 8px;
  background-color: var(--color-neutral-000-full);
  ${styleWrappedComponent(
    css`
      margin-bottom: 0;
      ${alpha.primaryInactive.caption};
      text-transform: none;
    `
  )};
`;

type GroupHeadingProps = SelectComponentProps["GroupHeading"];

export const GroupHeading: FC<GroupHeadingProps> = ({ children, ...props }) => (
  <StyledGroupHeading>
    <components.GroupHeading {...props}>{children}</components.GroupHeading>
  </StyledGroupHeading>
);
